import { ModelsAppModelStoreType } from "@/schemas/modelsAppModelStoreType";

export type StoreType = "ios" | "google_play" | "alt_stores";

const IOS_STORE_HOSTS = ["apple.com"];
const GOOGLE_PLAY_HOSTS = ["play.google.com"];
const ALT_STORE_HOSTS = ["rustore.ru", "appgallery.huawei.com", "app.mi.com", "getapps.com"];

const getHostname = (url: string) => {
    const trimmedUrl = url.trim().toLowerCase();

    if (!trimmedUrl) return "";

    try {
        return new URL(trimmedUrl).hostname;
    } catch {
        try {
            return new URL(`https://${trimmedUrl}`).hostname;
        } catch {
            return trimmedUrl;
        }
    }
};

const matchesHost = (hostname: string, host: string) => {
    return hostname === host || hostname.endsWith(`.${host}`);
};

export const detectKnownStoreFromUrl = (url: string): StoreType | undefined => {
    const hostname = getHostname(url);

    if (IOS_STORE_HOSTS.some((host) => matchesHost(hostname, host))) return "ios";
    if (ALT_STORE_HOSTS.some((host) => matchesHost(hostname, host))) return "alt_stores";
    if (GOOGLE_PLAY_HOSTS.some((host) => matchesHost(hostname, host))) return "google_play";

    return undefined;
};

export const detectStoreFromUrl = (url: string): StoreType => {
    return detectKnownStoreFromUrl(url) ?? "google_play";
};

const backendStoreTypeMap: Record<string, StoreType> = {
    [ModelsAppModelStoreType.APPLE]: "ios",
    [ModelsAppModelStoreType.GOOGLE]: "google_play",
    [ModelsAppModelStoreType.RU_STORE]: "alt_stores",
};

export const getStoreType = (app: {
    store_type?: ModelsAppModelStoreType;
    store_link?: string;
}): StoreType => {
    const storeTypeFromUrl = detectKnownStoreFromUrl(app.store_link ?? "");

    if (storeTypeFromUrl) return storeTypeFromUrl;
    if (app.store_type) return backendStoreTypeMap[app.store_type] ?? "google_play";
    return "google_play";
};
